<template>
  <div class="collapse-titles w-100" v-if="quote">
    <section class="section">
      <div
        class="collapse-item d-flex justify-items-between align-items-center mb-5"
        v-b-toggle.title1
      >
        <h2
          @click="scrollTo"
          class="text-primary m-0 ml-2"
          v-if="content.pv_infoblock_productsandwarranties"
          v-dynamic-content:pv_infoblock_productsandwarranties
        ></h2>
      </div>
      <b-collapse id="title1" accordion="extra-info">
        <detail-products-warranties :quote="quote"></detail-products-warranties>
      </b-collapse>
    </section>
    <section class="section" v-if="showFinancingSection">
      <div
        class="collapse-item d-flex justify-items-between align-items-center mb-5"
        v-b-toggle.title_finance_section
      >
        <h2
          @click="scrollTo"
          class="text-primary m-0 ml-2"
          v-dynamic-content:pv_tab_header_financing
        ></h2>
      </div>
      <b-collapse id="title_finance_section" accordion="extra-info">
        <detail-financing :quote="quote"></detail-financing>
      </b-collapse>
    </section>
    <section class="section">
      <div
        class="collapse-item d-flex justify-items-between align-items-center mb-5"
        v-b-toggle.title2
      >
        <h2
          @click="scrollTo"
          class="text-primary m-0 ml-2"
          v-if="content.pv_infoblock_installationandmonitoring"
          v-dynamic-content:pv_infoblock_installationandmonitoring
        ></h2>
      </div>
      <b-collapse id="title2" accordion="extra-info">
        <detail-installation-monitoring :quote="quote"></detail-installation-monitoring>
      </b-collapse>
    </section>
    <section class="section" v-if="content.pv_infoblock_environmental">
      <div
        class="collapse-item d-flex justify-items-between align-items-center mb-5"
        v-b-toggle.title3
      >
        <h2
          @click="scrollTo"
          class="text-primary m-0 ml-2"
          v-dynamic-content:pv_infoblock_environmental
        ></h2>
      </div>
      <b-collapse id="title3" accordion="extra-info">
        <detail-environment :quote="quote"></detail-environment>
      </b-collapse>
    </section>
    <section class="section" v-if="isIChoosr">
      <div
        class="collapse-item d-flex justify-items-between align-items-center mb-5"
        v-b-toggle.title4
      >
        <h2
          @click="scrollTo"
          class="text-primary m-0 ml-2"
          v-if="content.pv_infoblock_additional_labor_costs"
          v-dynamic-content:pv_infoblock_additional_labor_costs
        ></h2>
      </div>
      <b-collapse id="title4" accordion="extra-info">
        <detail-additional-labor :quote="quote"></detail-additional-labor>
      </b-collapse>
    </section>
  </div>
</template>

<script>
import DetailInstallationMonitoring from '@/components/quotes/DetailInstallationMonitoring'
import DetailEnvironment from '@/components/quotes/DetailEnvironment'
import DetailProductsWarranties from '@/components/quotes/DetailProductsWarranties'
import DetailAdditionalLabor from '@/components/quotes/DetailAdditionalLabor'
import DetailFinancing from '@/components/quotes/DetailFinancing'
import { mapGetters } from 'vuex'

export default {
  name: 'Collapse',
  props: ['quote'],
  components: {
    DetailProductsWarranties,
    DetailInstallationMonitoring,
    DetailEnvironment,
    DetailAdditionalLabor,
    DetailFinancing,
  },
  computed: {
    ...mapGetters(['showFinancingSection', 'isIChoosr']),
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    async scrollTo(event) {
      await this.sleep(500)
      const yPos = event.target.getBoundingClientRect().top + document.documentElement.scrollTop
      window.scrollTo({ top: yPos - 80, left: 0, behavior: 'smooth' })
    },
  },
}
</script>
